angular.module('gym.components').directive('ezidebitBankAccountForm', function() {
  return {
    restrict: 'EA',
    scope: {
      gym: '=',
      contact: '=',
      customer: '=',
      updateThisContactOnly: '=',
      paymentAccount: '=',
      closeModal: '&',
      isCustomerExist: '&',
      onCreate: '&',
      onUpdate: '&'
    },
    template: require('templates/components/contacts/wallet/ezidebit_bank_account_form.html.slim'),
    controller: ["$scope", "$timeout", "EzidebitService", function($scope, $timeout, EzidebitService) {
      var bankAccount, enableForm, endpoint, getWalletDetails, initChangePaymentDetails, initCreateCustomer, onCreate, onError, onSuccess, onUpdate, publicKey;
      publicKey = $scope.paymentAccount.public_key;
      endpoint = $scope.paymentAccount.payment_system_url;
      $scope.bankAccount = bankAccount = {
        firstName: $scope.contact.contact_information.first_name,
        lastName: $scope.contact.contact_information.last_name
      };
      $scope.customerReference = EzidebitService.getCustomerReference({
        gymId: $scope.gym.id,
        contactId: $scope.contact.id,
        context: 'CP'
      });
      initChangePaymentDetails = function() {
        return $timeout(function() {
          window.initEziDebit();
          return eziDebit.init(publicKey, {
            submitAction: 'ChangeCustomerPaymentInfo',
            submitButton: 'submit-ezidebit-bank-account-form',
            submitCallback: onUpdate,
            submitError: onError,
            customerRef: 'customerRef',
            accountName: 'accountName',
            accountBSB: 'bsb',
            accountNumber: 'accountNumber'
          }, endpoint);
        });
      };
      initCreateCustomer = function() {
        return $timeout(function() {
          var params;
          params = {
            submitAction: 'SaveCustomerAccount',
            submitButton: 'submit-ezidebit-bank-account-form',
            submitCallback: onCreate,
            submitError: onError,
            customerFirstName: 'firstName',
            customerLastName: 'lastName',
            accountName: 'accountName',
            accountBSB: 'bsb',
            accountNumber: 'accountNumber',
            customerReference: 'customerReference'
          };
          if ($scope.customer.clean_contact_email) {
            params.customerEmail = 'customerEmail';
          }
          if ($scope.customer.clean_contact_mobile_number) {
            params.customerMobile = 'customerMobile';
          }
          window.initEziDebit();
          return eziDebit.init(publicKey, params, endpoint);
        });
      };
      if ($scope.isCustomerExist()) {
        initChangePaymentDetails();
      } else {
        initCreateCustomer();
      }
      onSuccess = function(response) {
        $scope.bankAccount.error_message = void 0;
        enableForm();
        return getWalletDetails(response.Data);
      };
      onUpdate = function(response) {
        return $timeout(function() {
          var customer;
          customer = onSuccess(response);
          return $scope.onUpdate({
            customer: customer
          });
        });
      };
      onCreate = function(response) {
        return $timeout(function() {
          var customer;
          customer = onSuccess(response);
          return $scope.onCreate({
            customer: customer
          });
        });
      };
      onError = function(error) {
        return $timeout(function() {
          enableForm();
          return $scope.bankAccount.error_message = error;
        });
      };
      $scope.$watch('bankAccount.form.$valid', function(value) {
        return $scope.$emit('contact:paymentMethod:formStatusChanged', value);
      });
      getWalletDetails = function(customer) {
        var length, wallet;
        length = bankAccount.accountNumber.length;
        wallet = {
          customer_ref: customer.CustomerRef || $scope.customer.customer_ref,
          last4: bankAccount.accountNumber.substr(length - 4),
          full_name: bankAccount.accountName,
          bsb: bankAccount.bsb,
          rootObjectName: 'payment_method',
          payment_method: 'bank_account'
        };
        wallet.exp_month = '';
        wallet.exp_year = '';
        return wallet;
      };
      return enableForm = function() {
        return $scope.isFormDisabled = false;
      };
    }]
  };
});
